<template>
  <v-container v-if="!isLoading">
    <v-layout column>
      <v-card>
        <v-card-text>
          <v-row v-if="userRoles=='ADMIN'">
            <v-col md="6" class="col-xs-12">
              <v-select
                v-model="selectedDashboarderId"
                :items="dashboardersList"
                item-text="email"
                item-value="id"
                label="Dashboarders List"
              ></v-select>
            </v-col>
            <v-col md="6" class="col-xs-12">
              <v-autocomplete
                v-model="selectedCampaigns"
                :items="campaignsList"
                :item-text="getCampaignText"
                item-value="id"
                label="Campaigns List"
                small-chips
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col md="12" class="col-xs-12">
              <!-- <v-autocomplete
                v-model="selectedCampaigns"
                :items="campaignsList"
                :item-text="getCampaignText"
                item-value="id"
                label="Campaigns List"
                multiple
                chips
              ></v-autocomplete> -->
            </v-col>
          </v-row>
          <v-row md="12">
            <v-col md="6">
              <date-picker :max="dates[1]" required icon="mdi-calendar" label="Start Date" v-model="dates[0]"></date-picker>
            </v-col>
            <v-col md="6">
              <date-picker :min="dates[0]" required icon="mdi-calendar" label="End Date" v-model="dates[1]"></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="4" class="col-xs-12">
              <widget
                icon="mdi-checkbox-marked-circle"
                :title="totals.confirmed"
                subTitle="Accepted"
                color="#8bc34a"
              />
            </v-col>
            <v-col md="4" class="col-xs-12">
              <widget
                icon="mdi-close-circle"
                :title="totals.rejected"
                subTitle="Rejected"
                color="#ff5722"
              />
            </v-col>
            <v-col md="4" class="col-xs-12">
              <widget
                icon="mdi-clipboard-plus"
                :title="totals.all"
                subTitle="Total"
                color="#607d8b"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6" class="col-xs-12">
              <v-card>
                <v-card-title>
                  <v-row>
                    <v-col md="8" class="col-xs-12">
                      <span>Daily Performance</span>
                    </v-col>
                    <v-col md="4" class="col-xs-12">
                      <v-card color="light-green">
                        <v-card-text>Total: {{this.totalRange}}</v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text v-if="!loadingStatus.dateRange">
                  <column-chart
                    :data="rangePerformance"
                    label="Receipts Read"
                    :messages="{empty: 'No data to show.'}"
                  ></column-chart>
                </v-card-text>
                <v-card-text v-else>
                  <v-flex class="loader-box">
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col md="6" class="col-xs-12">
              <v-card>
                <v-card-title>
                  <v-row>
                    <v-col md="8" class="col-xs-12" style="display: flex; align-items: center;">
                      <span>Monthly Performance</span>
                    </v-col>
                    <v-col md="4" class="col-xs-12">
                      <v-card color="light-green">
                        <v-card-text>Total: {{this.totalMonthly}}</v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text v-if="!loadingStatus.monthly">
                  <column-chart
                    :data="monthlyPerformance"
                    label="Receipts Read"
                    :messages="{empty: 'No data to show.'}"
                  ></column-chart>
                </v-card-text>
                <v-card-text v-else>
                  <v-flex class="loader-box">
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import DatePicker from "./../DatePicker.vue";
import { mapFields } from '../../store/helpers';

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      selectedCampaigns: [],
      monthlyPerformance: [],
      rangePerformance: [],
      totalRange: 0,
      totalMonthly: 0,
      totals: {
        confirmed: 0,
        rejected: 0,
        all: 0
      },
      selectedDashboarderId: -1,
      isLoading: true,
      loadingStatus: {
        dateRange: true,
        monthly: true
      },
      dataSource: { name: "All Dashboarders", id: 0 },
      dateRangeMenu: false,
      dates: [
        moment(Date.now())
          .subtract(1, "M")
          .format("YYYY-MM-DD"),
        moment(Date.now()).format("YYYY-MM-DD")
      ],
      campaignsList: []
    };
  },
  computed: {
    ...mapGetters([
      "dashboarder",
      "campaign",
      "userToken",
      "dashboardersList",
      "isAdmin",
      "selectedDashboard",
      "userRoles"
    ]),
    ...mapFields(["campaign_fk"]),

    dateRangeText() {
      this.updateData({ dateRange: true });
      return this.dates.join(" - ");
    }
  },
  methods: {
    ...mapActions([
      "getDashboarder",
      "getCampaign",
      "getDashboardData",
      "searchPerformance"
    ]),
    getCampaignText(item) {
      return `#${item.id} ${item.title}`;
    },
    updateData(options) {
      if (options.monthly) {
        this.loadingStatus.monthly = true;
      }
      if (options.dateRange && this.dates.length === 2) {
        this.loadingStatus.dateRange = true;
        const payload = {
          userToken: this.userToken,
          dashboarderId:
            this.selectedDashboarderId !== -1 ? this.selectedDashboarderId : "",
          campaignId: this.selectedCampaigns,
          dateStart: this.dates[0],
          dateEnd: this.dates[1],
          dashboard:this.selectedDashboard
        };
        let count1 = 0;
        let count2 = 0;
        this.totalRange = count1;
        this.totalMonthly = count2;
        this.rangePerformance = [];
        this.monthlyPerformance = [];

        this.searchPerformance(payload).then(result => {
          result.dailyPerformance.forEach(per => {
            this.rangePerformance.push([per.day, per.count]);
            count1 += per.count;
            this.totalRange = count1;
          });

          result.monthlyPerformance.forEach(per => {
            this.monthlyPerformance.push([per.month, per.count]);
            count2 += per.count;
            this.totalMonthly = count2;
          });
          this.loadingStatus.dateRange = false;
          this.loadingStatus.monthly = false;
            this.totals.confirmed = 0
            this.totals.all = 0
            this.totals.rejected = 0
            result.totals.forEach(r=>{
              if (r.opType =="Confirm") this.totals.confirmed = r.count
              if (r.opType =="Reject") this.totals.rejected = r.count
            })
            this.totals.all = this.totals.confirmed + this.totals.rejected
        });
      }
    }
  },
  watch: {
    selectedCampaigns(val) {
      this.updateData({ monthly: true, dateRange: true });

      const payload = {
          userToken: this.userToken,
          dashboard: this.selectedDashboard,
          campaign_fk: this.selectedCampaigns
        };
      this.getDashboardData(payload); //get a list of all dashboarders for drop down

    },
    selectedDashboarderId(val) {
      this.updateData({ monthly: true, dateRange: true });
    },
    dataSource(val) {
    },
    dates: {
      handler: function(val) {
        this.updateData({ monthly: true, dateRange: true });
      },
      deep: true
    }
  },
  mounted() {
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));

    // Set the campaign List
    this.campaignsList = this.selectedDashboard.campaigns ? Object.keys(this.selectedDashboard.campaigns) : []
    console.log("DASHBOARDS" , Object.keys(this.selectedDashboard.campaigns))
    const payload = {
          userToken: this.userToken,
          dashboard: this.selectedDashboard
        };
    this.getDashboardData(payload); //get a list of all dashboarders for drop down
    this.updateData({ monthly: true, dateRange: true });
    this.isLoading = false;

  }
};
</script>

<style>
@media (max-width: 960px) {
  .col-xs-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.loader-box {
  display: flex;
  justify-content: center;
}
</style>
